import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { installClientTelemetry } from "./lib/clientTelemetry";
import "./styles/base.css";

installClientTelemetry();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
